import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ChatBox } from "../../components/ChatBox/ChatBox";
import { useSpreadSheetRd } from "../../context/spreadsheet-context-rd";
import {
  listenerSingularCellSelection,
  listenerMultipleCellSelection,
  listenerEditedCellData,
  // listenerCellStyle,
  listenerAddSheet,
  listenerClients,
  listenerOnChanged,
  emitRoomID,
  listenerClientArrOnDisconnect,
  listenAddMember


  // emitOnChanged,
} from "../../socket";
import MouseContainer from "../mousecontainer";
import { workwiseServices } from "../../Workw-Api/api";
import { useDocument } from "./documentInfoContex";
import WaterMark from "../../components/WaterMark";
import { loadServerData } from "../../utils/api";
import { formatFileSize } from "../../utils/helper";
import Loader from "../../components/SkeletonLoader/Loader";
import { message } from "antd";


export const SpreadsheetContainerRd = ({
  contentLoading,
  setContentLoading,
}) => {
  const {
    setSheets,
    setDocumentInfo,
    setIsExternalAllow,
    isReadOnly,
    conflictPreviewVerion,
    setServerData,
    setSavingData
  }
    = useDocument();

  const { id } = useParams();
  const { setCurrPos } = useSpreadSheetRd();
  const [isSpreadsheetReady, setIsSpreadsheetReady] = useState(false);
  const [docExistsInDb, setIsDocSaved] = React.useState(false);
  const [serverVersionData, setServerVersionData] = useState(null);
  const [dataFetchSuccess, setDataFetchSuccess] = useState(false);

  // const konn = "http://192.168.18.81:8080";
  const konn = "https://grid.workw.com";
  // const konn = "http://localhost:8080";

  const url_string = window.location.href; //window.location.href
  const url = new URL(url_string);
  const milegridURL = url.searchParams.get("gridname");
  let msg

  const {
    spreadSheet_init,
    spreadsheetInstanceRef,
    onCellSelected,
    onCellsSelected
    //   onChanged,
  } = useSpreadSheetRd();

  useEffect(() => {
    const fetchServerData = async () => {
      setContentLoading(true);
      try {
        const serverData = await loadServerData(id);
        setServerData(serverData);
        setServerVersionData(serverData);
        setDataFetchSuccess(true);
      } catch (error) {
        console.error(`Error loading data for sheet ${id}:`, error);
        message.error('Failed to load spreadsheet data');
        setDataFetchSuccess(false);
      } finally {
        setContentLoading(false);
      }
    };

    if (docExistsInDb) {
      fetchServerData();
    }
  }, [id, docExistsInDb]);

  useEffect(() => {
    const loadSpreadsheetData = (data, isExternal) => {
      if (!data || !Array.isArray(data)) {
        message.error('Invalid or missing spreadsheet data');
        return;
      }

      const finalData = data.filter(item => Object.keys(item).length > 0);
      const fileSize = formatFileSize(new TextEncoder().encode(JSON.stringify(finalData)).length);
      setIsExternalAllow(isExternal);
      setSavingData({ isSaving: '', lastSavedDateTime: '', fileSize });
      setSheets(finalData);
      spreadsheetInstanceRef.current.loadData(finalData, false);
      const allSheetsData = spreadsheetInstanceRef.current.getData();
      const activeSheetData = allSheetsData[0] || null;
      if (activeSheetData && finalData.length === 0) {
        setSpreadsheetData(activeSheetData);
      }
      return finalData;
    };

    const initializeSpreadsheet = async () => {
      // Exit early if spreadsheet is already initialized
      if (isSpreadsheetReady) return;

      // Only proceed if not loading, data fetch was successful, and serverVersionData exists
      if (contentLoading || !dataFetchSuccess || !serverVersionData) return;

      try {
        // Fetch data from localStorage or server before initialization
        let finalData;
        if (conflictPreviewVerion === 'offline') {
          let offlineSheets;
          try {
            offlineSheets = JSON.parse(localStorage.getItem('offlineSheets') || '{}');
          } catch (error) {
            console.error('Failed to parse offlineSheets from localStorage:', error);
            message.error('Failed to load offline data');
            return;
          }
          finalData = offlineSheets[id]?.data;
        } else {
          finalData = serverVersionData?.spreadsheetData || [];
        }

        // Validate data before proceeding
        if (!finalData || !Array.isArray(finalData)) {
          message.error('Unable to load content. Data missing or unavailable.');
          return;
        }

        // Initialize spreadsheet instance only after data is fetched
        if (!isSpreadsheetReady) {
          await spreadSheet_init();
        }
        // Load data into spreadsheet
        loadSpreadsheetData(finalData, serverVersionData.isExternal);
        setIsSpreadsheetReady(true);

      } catch (error) {
        console.error('Spreadsheet initialization failed:', error);
        message.error('Failed to initialize spreadsheet');
      }
    };

    initializeSpreadsheet();
  }, [contentLoading, serverVersionData, dataFetchSuccess, isSpreadsheetReady, id, conflictPreviewVerion]);


  useEffect(() => {
    if (isSpreadsheetReady && spreadsheetInstanceRef.current) {
      onCellSelected(id);
      // Setup change listener
      const changeHandler = (data) => {
        setSpreadsheetData(data);
      };
      spreadsheetInstanceRef.current.change(changeHandler);
      onCellsSelected(id)
      listenerAddSheet(spreadsheetInstanceRef);
      listenerSingularCellSelection(spreadsheetInstanceRef, msg = 'Reader');
      listenerEditedCellData(spreadsheetInstanceRef);
      listenerOnChanged(spreadsheetInstanceRef);
      listenerClients(spreadsheetInstanceRef)
      // listenerClientArrOnDisconnect();
      listenerMultipleCellSelection(spreadsheetInstanceRef)
      listenAddMember(() => {
        setTimeout(async () => {
          const response = await workwiseServices.getDocumentById(id);
          if (response?.status == 200 && response.data?.data?.rightType !== 0 && response.data?.data) {

            setDocumentInfo(response.data.data)
            console.log('listenAddMember');
          }


        }, 2000)
      }
      )
    }
  }, [isSpreadsheetReady, id]);

  // console.log(id);

  React.useEffect(() => {
    emitRoomID(id);
  }, [id]);

  useEffect(() => {
    const createSpreadsheet = async () => {
      const response = await axios.post(
        `${konn}/api/create`,
        {
          id: id,
          data: {},
        }
      );
      setIsDocSaved(true);
      // console.log(response);
    };
    createSpreadsheet();
  }, [id]);

  const [spreadsheetData, setSpreadsheetData] = React.useState([]);

  React.useEffect(() => {
    const updateSpreadsheet = async (data) => {
      const response = await axios.post(
        `${konn}/api/update`,
        {
          spreadsheetID: id,
          spreadsheetData: data,
        }
      );
      // console.log(response);
    };

    let timer = setTimeout(async () => {
      updateSpreadsheet(spreadsheetData);
    }, 100);

    return () => clearTimeout(timer);
  }, [spreadsheetData, id]);

  return (
    <div id="spreadsheet-container">
      {contentLoading || !isSpreadsheetReady ? (
        <Loader />
      ) : (
        <>
          {
            !conflictPreviewVerion &&
            <>
              <ChatBox />
              <WaterMark />
              <MouseContainer />
            </>
          }
        </>
      )}
    </div>
  );
};
